module.exports = __webpack_public_path__ + "static/media/STFU-2.6551d960.png";